// extracted by mini-css-extract-plugin
export default {"productDetail_head":"productsDetailHead_productDetail_head__7xzIy"};